import { render, staticRenderFns } from "./RemittanceOrderManagement.vue?vue&type=template&id=66535f1e&scoped=true"
import script from "./RemittanceOrderManagement.vue?vue&type=script&lang=js"
export * from "./RemittanceOrderManagement.vue?vue&type=script&lang=js"
import style0 from "./RemittanceOrderManagement.vue?vue&type=style&index=0&id=66535f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66535f1e",
  null
  
)

export default component.exports